import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { pxToRem } from '../../../utils/pxToRem';

export interface SpeakerCardProps {
  name: string;
  title: string;
  photoSrc: string;
}

export function SpeakerCard({ name, title, photoSrc }: SpeakerCardProps) {
  return (
    <Stack
      gap={pxToRem(12)}
      sx={{
        width: pxToRem(160),
        color: 'primary.main',
      }}
    >
      <Box
        component="img"
        src={photoSrc}
        alt={name}
        sx={{
          width: pxToRem(160),
          height: pxToRem(160),
          borderRadius: pxToRem(17),
          objectFit: 'cover',
          display: 'block',
        }}
      />
      {/* Figma: centred text on mobile (28:173), left-aligned in the desktop grid (58:1279) */}
      <Stack gap={0} sx={{ textAlign: { mobile: 'center', laptop: 'left' } }}>
        <Typography
          component="p"
          sx={{
            fontFamily: '"Roboto", sans-serif',
            fontWeight: 900,
            fontSize: pxToRem(16),
            lineHeight: pxToRem(20),
            textTransform: 'uppercase',
            margin: 0,
          }}
        >
          {name}
        </Typography>
        <Typography
          component="p"
          sx={{
            fontFamily: '"Roboto", sans-serif',
            fontWeight: 400,
            fontSize: { mobile: pxToRem(12), laptop: pxToRem(16) },
            lineHeight: pxToRem(20),
            textTransform: 'capitalize',
            margin: 0,
          }}
        >
          {title}
        </Typography>
      </Stack>
    </Stack>
  );
}
